import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

// Public
export const fetchChannels = () => api.get("/channels").then(r => r.data);
export const fetchChannel = (slug) => api.get(`/channels/${slug}`).then(r => r.data);
export const fetchLibrary = (params = {}) => api.get("/library", { params }).then(r => r.data);
export const fetchContent = (id) => api.get(`/library/${id}`).then(r => r.data);
export const searchContent = (q) => api.get("/search", { params: { q } }).then(r => r.data);
export const fetchBooks = () => api.get("/books").then(r => r.data);
export const fetchTvGuide = () => api.get("/tv-guide").then(r => r.data);
export const fetchNews = () => api.get("/news").then(r => r.data);
export const fetchNewsItem = (id) => api.get(`/news/${id}`).then(r => r.data);
export const fetchAdSlots = () => api.get("/ad-slots").then(r => r.data);
export const serveAds = (slot, channel_id) => api.get("/ads/serve", { params: { slot, channel_id } }).then(r => r.data);

// User features
export const fetchMyList = () => api.get("/me/list").then(r => r.data);
export const addToMyList = (id) => api.post(`/me/list/${id}`).then(r => r.data);
export const removeFromMyList = (id) => api.delete(`/me/list/${id}`).then(r => r.data);
export const fetchContinueWatching = () => api.get("/me/continue").then(r => r.data);
export const saveProgress = (content_id, position_sec, duration_sec) => api.post("/me/progress", { content_id, position_sec, duration_sec }).then(r => r.data);
export const fetchMyAds = () => api.get("/me/ads").then(r => r.data);
export const createMyAd = (body) => api.post("/me/ads", body).then(r => r.data);
export const fetchMyPurchases = () => api.get("/me/purchases").then(r => r.data);

// Auth extras
export const forgotPassword = (email) => api.post("/auth/forgot-password", { email }).then(r => r.data);
export const resetPassword = (token, password) => api.post("/auth/reset-password", { token, password }).then(r => r.data);

// Payments
export const createCheckout = (lookup_key, metadata = {}, quantity = 1) =>
  api.post("/payments/checkout", { lookup_key, quantity, origin_url: window.location.origin, metadata }).then(r => r.data);
export const paymentStatus = (session_id) => api.get(`/payments/status/${session_id}`).then(r => r.data);

// Admin
export const adminListChannels = () => api.get("/admin/channels").then(r => r.data);
export const adminCreateChannel = (b) => api.post("/admin/channels", b).then(r => r.data);
export const adminUpdateChannel = (slug, b) => api.put(`/admin/channels/${slug}`, b).then(r => r.data);
export const adminDeleteChannel = (slug) => api.delete(`/admin/channels/${slug}`).then(r => r.data);
export const adminAddProgram = (slug, b) => api.post(`/admin/channels/${slug}/programs`, b).then(r => r.data);
export const adminRemoveProgram = (slug, pid) => api.delete(`/admin/channels/${slug}/programs/${pid}`).then(r => r.data);
export const adminCreateContent = (b) => api.post("/admin/library", b).then(r => r.data);
export const adminUpdateContent = (id, b) => api.put(`/admin/library/${id}`, b).then(r => r.data);
export const adminDeleteContent = (id) => api.delete(`/admin/library/${id}`).then(r => r.data);
export const adminListUsers = () => api.get("/admin/users").then(r => r.data);
export const adminListAds = (status) => api.get("/admin/ads", { params: status ? { status } : {} }).then(r => r.data);
export const adminApproveAd = (id) => api.post(`/admin/ads/${id}/approve`).then(r => r.data);
export const adminRejectAd = (id) => api.post(`/admin/ads/${id}/reject`).then(r => r.data);
export const adminDeleteAd = (id) => api.delete(`/admin/ads/${id}`).then(r => r.data);
export const adminListNews = () => api.get("/admin/news").then(r => r.data);
export const adminCreateNews = (b) => api.post("/admin/news", b).then(r => r.data);
export const adminDeleteNews = (id) => api.delete(`/admin/news/${id}`).then(r => r.data);
export const adminRefreshRss = () => api.post("/news/refresh-rss").then(r => r.data);
